import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import {Container,Button} from "reactstrap";

//Import Breadcrumb
import "../Tables/datatables.scss";

//i18n
import { withNamespaces } from "react-i18next";

import { connect } from "react-redux";

//Import form component to render
import UpdateTaskForm from "../../components/Forms/UpdateTaskForm";
import Loader from "../../components/Common/Loader"
class UpdateTask extends Component {
  constructor(props) {
    super(props);
    let page_origin="/tasks"
    if(this.props.location.query){
      page_origin=this.props.location.query.page_origin
    }
    this.state = {
      user: JSON.parse(localStorage.getItem("authUser")),
      origin_page:page_origin,
    };
  }
  goBack(event){
    event.preventDefault()
    this.props.history.push(this.state.origin_page)
  }
  render() {
    let user = this.state.user;
    console.log("USER: ", !user);
    if (!user) {
      return (
        <React.Fragment>
        <Loader></Loader>
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <div className="user-management">
          <Container fluid>
            <Button onClick={(event)=>this.goBack(event)} className="btn btn-primary waves-effect waves-light buttonStatus usersButtons">
             
                {this.props.t("Atrás")}
       
            </Button>
            <UpdateTaskForm />
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateProps = (state) => {
  return {  };
};
export default withRouter(
  connect(mapStateProps, {})(withNamespaces()(UpdateTask))
);
